import { connect } from 'react-redux';
import LuckyGameConfig from '../component/LuckyGameConfig';
import actions from '../redux/actions/prize';
import campaignActions from '../redux/actions/campaign';

const mapStateToProps = (state) => ({
  prize: state.prize.prizes,
  config: state.prize.config,
  configPrizes: state.prize.configPrizes,
});

const mapDispatchToProps = (dispatch) => ({
  fetchPrize: () => {
    dispatch(actions.fetchPrize());
  },
  createPrize: (data) => {
    dispatch(actions.createPrize(data));
  },
  updatePrize: (data) => {
    dispatch(actions.updatePrize(data));
  },
  updateConfig: (data) => {
    dispatch(campaignActions.onUpdateCampaignConfigAction(data));
  },
  fetchConfig: () => {
    dispatch(actions.fetchLuckyGameConfig());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LuckyGameConfig);
